import { generateIDBStores } from '../../utils/idb/stores';

export enum UnSyncedStores {
  Records = 'Records',
}

export const unSyncedStores = generateIDBStores(Object.values(UnSyncedStores));

export enum PendingQueueStore {
  QueueInfo = 'QueueInfo',
  UnsentQueue = 'UnsentChanges',
  UnprocessedQueue = 'UnprocessedChanges',
  EntityDBInfo = "EntityDBInfo"
}

export enum QueueInfoKey {
  Unsent = 'Unsent',
  UnProcessed = 'UnProcessed',
}

export const pendingQueueStores = generateIDBStores(
  Object.values(PendingQueueStore)
);
